module.exports = __webpack_public_path__ + "img/2024122601.1e2e53a9.png";